import WheelBonusRecord from "integration/records/wheel-bonus-record";
import { User } from "slotworks/integration/revolver/schema/spin-record-schema";
import gameState from "slotworks/model/game-state";
import Gameplay from "slotworks/model/gameplay/gameplay-model";
import Record from "slotworks/model/gameplay/records/record";
import { RecordBuilder } from "slotworks/server/builders/record-builder";

class WheelBonusRecordBuilderBase implements RecordBuilder { 

    public filter(data: any): boolean {
        let wheelResponse: WheelResponseSchema;

        if (data) {
            wheelResponse = data.data as WheelResponseSchema;
        }

        return wheelResponse && wheelResponse.RESULTS !== undefined && wheelResponse.RESULTS.game === "WHEEL_BONUS";
    }

    public build(gameplay: Gameplay, data: any): Record[] {
        const wheelResponse: WheelResponseSchema = data.data as WheelResponseSchema;

        const record = new WheelBonusRecord();
        record.is_complete = wheelResponse.RESULTS.state.is_complete;
        record.giftedAdditional = wheelResponse.RESULTS.state.giftedAdditional;
        record.totalCreditsWon = wheelResponse.RESULTS.state.total_win_cash;
        record.total = wheelResponse.RESULTS.state.total;
        record.remain = wheelResponse.RESULTS.state.remain;

        const win = parseFloat(wheelResponse.RESULTS.total_win_cash as any)
        record.creditsWon = win;
        gameplay.totalCreditsWon += win;
        gameState.updateNetPosition(win);
        if(gameplay.inFreespinsGame) {
            gameplay.totalFreespinsCreditsWon += win;
        }
        
        return [record];
    }

}
const WheelBonusRecordBuilder = new WheelBonusRecordBuilderBase();
export default WheelBonusRecordBuilder;

export interface WheelResponseSchema {
    RESULTS: Results;
    USER: User;
    time: number;
}

export interface Results {
    additionalData: any;
    eval: Eval;
    game: string;
    next_game: string;
    games_pending: boolean;
    round_id: number;
    total_bet_cash: number;
    total_win_cash: number;
    state: State;
}

export interface Eval {
    freeSpinsCount: number;
    multiplier: number;
    version: string;
}

export interface State {
    buyoutGame: boolean;
    giftedAdditional: number;
    rounds: number;
    is_complete: boolean;
    is_retrigger: boolean;
    game: string;
    total_win_cash: number;
    total: number;
    remain: number;
    spins: number;
    spins_won: number;
    retriggers: number;
    spin_pending: boolean;
}